import { ElasticSearchResponse, Finition, FinitionDocument } from '@shared/services/elastic-search/models';

export const finitionsSerializer = (response: ElasticSearchResponse<FinitionDocument>): Finition[] =>
  response.hits.hits.map((hit) => {
    const source = hit._source;
    return {
      url: source.field_page_link?.[0] ?? '',
      image: source.field_visuel?.[0] ?? null,
      name: source.name?.[0] ?? '',
      description: source.description?.[0] ?? '',
    };
  });
